<template lang="pug">
    layout

        // Title
        title-component(
            :title="$t('profile.navigation[2].title')"
            slot="title"
            type="h2"
        )

        div

            // Password change form
            reminder-form

        v-layout(raw wrap)
            v-flex(xs12)

                // Horizontal line
                separator-component

                div.controls
                    div

                        // Cancel button
                        button-component.ml-0(
                            :action="getRemindersSettings"
                            :isLoading="isLoading"
                            color="grey"
                            large
                            outline
                        ) {{ $t('defaultButtons.cancel') }}

                    div

                        // Submit button
                        button-component.mr-0.submit(
                            color="primary"
                            :action="setRemindersSettings"
                            :isLoading="isLoading"
                            large
                        ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../Layout';
    import ReminderForm from './ReminderForm';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            ReminderForm,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapGetters('reminders', ['isLoading'])
        },
        created() {
            this.getRemindersSettings();
        },
        methods: {
            ...mapActions('reminders', [
                'getRemindersSettings',
                'setRemindersSettings'
            ])
        }
    };
</script>
